import Setting from './setting.js'

export default {
  ...Setting
}
